"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectionControls = exports.containerClass = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var data_structures_1 = require("@tableau/data-structures");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var reselect_1 = require("reselect");
var Localize_1 = require("../../../gen-src/Localize");
var MultiSelectionControls_1 = require("./MultiSelectionControls");
var SmallInlineFadeInSpinner_1 = require("./SmallInlineFadeInSpinner");
exports.containerClass = data_catalog_shared_1.cssClass('SingleSelectionControls_container', {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
});
var dividerClass = data_catalog_shared_1.cssClass('SingleSelectionControls_divider', __assign(__assign({}, MultiSelectionControls_1.margin), { display: 'inline-block', height: 20, width: 1, backgroundColor: widgets_1.TabStyles.Colors.L3 }));
var textClass = data_catalog_shared_1.cssClass('SingleSelectionControls_text', __assign(__assign({}, MultiSelectionControls_1.margin), { fontSize: widgets_1.TabStyles.Typography.Sizing.Default, color: widgets_1.TabStyles.Colors.L9 }));
var clearAndCountClass = data_catalog_shared_1.cssClass('SingleSelectionControls_clearAndCount', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
});
var SingleSelectionControls = /** @class */ (function (_super) {
    __extends(SingleSelectionControls, _super);
    function SingleSelectionControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleSelectionControls.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_apollo_1.ApolloConsumer, null, function (client) { return React.createElement(SingleSelectionControlsInternal, __assign({}, _this.props, { client: client })); }));
    };
    return SingleSelectionControls;
}(React.PureComponent));
exports.SingleSelectionControls = SingleSelectionControls;
var SingleSelectionControlsInternal = /** @class */ (function (_super) {
    __extends(SingleSelectionControlsInternal, _super);
    function SingleSelectionControlsInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.memoizedGetKeySetSize = reselect_1.defaultMemoize(data_structures_1.getKeySetSize);
        _this.state = {
            selecting: false,
        };
        return _this;
    }
    SingleSelectionControlsInternal.prototype.render = function () {
        return (React.createElement("span", { className: clearAndCountClass }, this.renderClearAndCountOrSelecting()));
    };
    SingleSelectionControlsInternal.prototype.renderClearAndCountOrSelecting = function () {
        if (this.state.selecting) {
            return React.createElement(SmallInlineFadeInSpinner_1.SmallInlineFadeInSpinner, null);
        }
        else {
            var selectedItemCount = this.memoizedGetKeySetSize(this.props.selectedKeys);
            if (selectedItemCount > 0) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.LowEmphasis, handleClick: this.props.clearSelection, style: MultiSelectionControls_1.buttonStyle, testId: 'clear' }, Localize_1.Messages.Clear()),
                    React.createElement("span", { className: dividerClass }),
                    React.createElement("span", { className: textClass }, Localize_1.Messages.XItemsSelected({
                        COUNT: selectedItemCount,
                        COUNT_LOC: Localize_1.Formatters.formatCount(selectedItemCount)
                    }))));
            }
            else {
                return null;
            }
        }
    };
    return SingleSelectionControlsInternal;
}(React.PureComponent));
//# sourceMappingURL=SingleSelectionControls.js.map